import { ProductGroupType } from '@@partner:types:app'
import React from 'react'

import { SelectPicker } from 'rsuite'


const productGroupTypes: { value: ProductGroupType; label: string }[] = [
  {
    value: 'system',
    label: 'Системная'
  },
  {
    value: 'custom',
    label: 'Другая'
  }
]


type props = {
  value: ProductGroupType
  onChange: (value: ProductGroupType) => void
}

export default function ProductGroupTypePicker ({ value, onChange }: props) {
  return (
    <SelectPicker
      data={productGroupTypes}
      value={value}
      onChange={onChange}
      cleanable={false}
      searchable={false}
    />
  )
}
